import Head from "../../elements/head/head";
import Footer from "../../elements/footer/footer";
import "./calendar.scss";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import BannerApp from "../../elements/banner/Banner";
import LeftSideBarApp from "../../elements/left_side_bar/Left_side_bar";
import Grid from "@mui/material/Grid";
import { useEffect, useState, useRef } from "react";
import FixedBottomNavigation from "../../elements/navigation/navigation";
import api from "../../api";
import ReactVirtualizedTable from "../calendar/table";
import { useDispatch } from "react-redux";
import { setCalendar } from "../../store/calendarSelector";
import Progress from "../../elements/progress/progress";
import { useSelector } from "react-redux";
import CustomizedTables from "../../elements/table/table_calendar";

const SideBar = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.color.secondary,
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Calendar = (args) => {
  // const calendar = useSelector((state) => state.calendarSelector.calendar);
  const [loading, setLoading] = useState(true);
  const countRef = useRef(0);
  const [totalTimeSpent, setTotalTimeSpent] = useState(null);
  const dispatch = useDispatch();
  const calendar = useSelector((state) => state.calendarSelector.calendar);
  const getCalendarFunc = () => {
    setLoading(true);
    api.getCal().then((response) => {
      dispatch(setCalendar(response.data.cal));
      // console.log(response.data.cal);
    });
    setLoading(false);
  };

  useEffect(() => {
    getCalendarFunc();
  }, []);

  return loading ? (
    <Progress load={loading} />
  ) : (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Head />
      </Grid>

      <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10, xl: 10 }}>
          <BannerApp />
        </Grid>

        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
      </Grid>

      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} container>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "none",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ md: 2, lg: 2, xl: 2 }}
        >
          <SideBar>
            <LeftSideBarApp />
          </SideBar>
        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }}>
          {/* <ReactVirtualizedTable /> */}
          {/* {calendar.length != 0 ? (
            calendar.map((column) => (
              <CustomizedTables data={column.calendar} />
            ))
          ) : (
            <h3>
              Вас приветствует Рязанская Федерация пауэрлифтинга! Тут пока
              пусто!
            </h3>
          )} */}
          <CustomizedTables data={calendar} />
        </Grid>
      </Grid>
      <Grid
        sx={{
          display: {
            xs: "none",
            sm: "none",
            md: "block",
            lg: "block",
            xl: "block",
          },
        }}
        size={{ lg: 1, xl: 1 }}
      ></Grid>

      <Grid size={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};

export default Calendar;
